import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Stack, Label } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ErrorString } from './error-string';

export const FixedTitleBar = (props) => {
  const {
    title, error,
  } = props;
  const i18n = useContext(I18nContext);

  const renderTitle = () => {
    let titleTpl = null;
    if (typeof title === 'string') {
      titleTpl = <Label className="collapse-title" >{i18n.getString(_TL_('{{item}}'), { item: title })}</Label>;
    } else {
      titleTpl = React.cloneElement(title);
    }

    return titleTpl;
  };

  const renderError = () => {
    if (!error || typeof error === 'string') {
      return <ErrorString error={error} />;
    }
    return React.cloneElement(error);
  };

  return (
    <Stack horizontal verticalAlign="top" horizontalAlign="space-between" className="collapse-title-bar" >
      <Stack.Item className="title-item" grow styles={{ root: { width: '857px' } }}>
        {renderTitle()}
      </Stack.Item>
      <div className="error-string-wrapper">
        {renderError()}
      </div>
    </Stack >
  );
};

FixedTitleBar.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
};
FixedTitleBar.defaultProps = {
  error: '',
};

